
import React from 'react';
import { useSelector } from 'react-redux';

import { Navigate, Outlet } from 'react-router-dom'


const PublicRoutes = (props) => {

    const isAuth = useSelector((state) => state.user.isAuthenticated)

    return isAuth ? <Navigate to="/" /> : <Outlet />
}

export default PublicRoutes;